import { LoadingButton } from '@mui/lab';
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { MuiFileInput } from 'mui-file-input';
import { FC, useState } from 'react';
import { toast } from 'react-toastify';

import { useUploadApplicationDocs } from '@features/applicationsDocs/hooks/useUploadApplicationDocs';
import  CloseIcon from '@mui/icons-material/Close';
import { UploadLogoIcon } from '../../../../vectors/index';
import { Done } from '@mui/icons-material';

type UploadApplicationDocModalProps = {
  isOpen: boolean;
  handleClose: () => void;
  applicationId: number;
};

const UploadApplicationDocModal: FC<UploadApplicationDocModalProps> = ({
  isOpen,
  handleClose,
  applicationId,
}) => {
  const [file, setFile] = useState<File | null>(null);
  const [errorText, setErrorText] = useState('');

  const { uploadDocument, isUploadingApplicationDocument } =
    useUploadApplicationDocs({ setErrorText, applicationId });

  const handleUpload = () =>
    uploadDocument(
      { application_doc: file },
      {
        onSuccess: () => {
          toast.success('File uploaded');
          setFile(null);
          handleClose();
        },
      },
    );

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <IconButton
          sx={{ position: 'absolute', right: 8, top: 8 }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          gap="10px"
        >
          <UploadLogoIcon />
          <Typography variant="h5">Upload Document</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1 }}>
          {errorText && <Alert severity="error">{errorText}</Alert>}
          <MuiFileInput
            variant="outlined"
            size="small"
            label="Upload file (pdf, doc, docx, jpg, jpeg, png)"
            value={file!}
            onChange={(newFile) => setFile(newFile)}
            InputProps={{
              placeholder: 'true',
              inputProps: {
                accept: '.pdf, .doc, .docx, .jpg, .jpeg, .png',
                placeholder: 'false',
              },
            }}
          />
          <LoadingButton
            variant="contained"
            disabled={!file}
            startIcon={<Done />}
            loading={isUploadingApplicationDocument}
            onClick={handleUpload}
          >
            Upload
          </LoadingButton>
          <Button
            startIcon={<CloseIcon />}
            onClick={handleClose}
            variant="outlined"
            color="secondary"
          >
            Go back
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default UploadApplicationDocModal;
